export enum BlockStatus {
  Pending = 0,
  InProgress = 1,
  Finish = 2,
}
